import { BaseModel } from '@shared/base.model';

import { PROGRAM_MODULE_FLAGS } from './program-module-flags.enum';
import { LoadDataRequirement } from './load-data-requirement.enum';
import { GenerationDesignDataRequirement } from './generation-design-data-requirement.enum';
import { RevenueDataRequirement } from './revenue-data-requirement.enum';
import { CostsDataRequirement } from './costs-data-requirement.enum';
import { DistributionDesignDataRequirement } from './distribution-design-data-requirement.enum';
import { FinancialDataRequirement } from './financial-data-requirement.enum';

export class ProgramProjectRules extends BaseModel<ProgramProjectRules> {
  informationModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  loadModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  generationDesignModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  distributionDesignModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  costsModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  revenueModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  financialModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  connectionsModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  milestonesModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  analyticsDataRequirementFlag: PROGRAM_MODULE_FLAGS;
  sharingModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  messagesModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  summaryModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  overviewModuleRequirementFlag: PROGRAM_MODULE_FLAGS;
  projectFilesModuleRequirementFlag: PROGRAM_MODULE_FLAGS;

  loadDataRequirements: LoadDataRequirement[];
  generationDesignDataRequirements: GenerationDesignDataRequirement[];
  revenueDataRequirements: RevenueDataRequirement[];
  costsDataRequirements: CostsDataRequirement[];
  distributionDesignDataRequirements: DistributionDesignDataRequirement[];
  financialDataRequirements: FinancialDataRequirement[];

  constructor(rules?: any) {
    super();
    this.informationModuleRequirementFlag = rules && rules.informationModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.loadModuleRequirementFlag = rules && rules.loadModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.generationDesignModuleRequirementFlag = rules && rules.generationDesignModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.distributionDesignModuleRequirementFlag = rules && rules.distributionDesignModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.costsModuleRequirementFlag = rules && rules.costsModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.revenueModuleRequirementFlag = rules && rules.revenueModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.financialModuleRequirementFlag = rules && rules.financialModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.connectionsModuleRequirementFlag = rules && rules.connectionsModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.milestonesModuleRequirementFlag = rules && rules.milestonesModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.analyticsDataRequirementFlag = rules && rules.analyticsDataRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.sharingModuleRequirementFlag = rules && rules.sharingModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    // Decoupled from "Project Submission" (sharing): a not-yet-migrated program has no messages flag
    // yet, so fall back to the sharing flag (mirrors the backend read-time fallback), else VISIBLE.
    this.messagesModuleRequirementFlag =
      (rules && rules.messagesModuleRequirementFlag)
      || (rules && rules.sharingModuleRequirementFlag)
      || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.summaryModuleRequirementFlag = rules && rules.summaryModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.overviewModuleRequirementFlag = rules && rules.overviewModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;
    this.projectFilesModuleRequirementFlag = rules && rules.projectFilesModuleRequirementFlag || PROGRAM_MODULE_FLAGS.VISIBLE;

    this.loadDataRequirements = rules && rules.loadDataRequirements || [];
    this.generationDesignDataRequirements = rules && rules.generationDesignDataRequirements || [];
    this.revenueDataRequirements = rules && rules.revenueDataRequirements || [];
    this.costsDataRequirements = rules && rules.costsDataRequirements || [];
    this.distributionDesignDataRequirements = rules && rules.distributionDesignDataRequirements || [];
    this.financialDataRequirements = rules && rules.financialDataRequirements || [];
  }
}
